var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 4.8001C8.95491 4.8001 5.99999 7.75502 5.99999 11.4001C5.99999 12.4921 6.26472 13.5205 6.73298 14.4263C6.77701 14.5115 6.79999 14.606 6.79999 14.7019V17.2001H9.29823C9.3941 17.2001 9.48859 17.2231 9.57376 17.2671C10.4796 17.7354 11.508 18.0001 12.6 18.0001C16.2451 18.0001 19.2 15.0452 19.2 11.4001C19.2 7.75502 16.2451 4.8001 12.6 4.8001ZM4.79999 11.4001C4.79999 7.09228 8.29217 3.6001 12.6 3.6001C16.9078 3.6001 20.4 7.09228 20.4 11.4001C20.4 15.7079 16.9078 19.2001 12.6 19.2001C11.3646 19.2001 10.1948 18.9125 9.15541 18.4001H6.19999C5.86862 18.4001 5.59999 18.1315 5.59999 17.8001V14.8447C5.0876 13.8052 4.79999 12.6355 4.79999 11.4001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.4001C11 11.8419 10.6418 12.2001 10.2 12.2001C9.75816 12.2001 9.39999 11.8419 9.39999 11.4001C9.39999 10.9583 9.75816 10.6001 10.2 10.6001C10.6418 10.6001 11 10.9583 11 11.4001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 11.4001C13.4 11.8419 13.0418 12.2001 12.6 12.2001C12.1582 12.2001 11.8 11.8419 11.8 11.4001C11.8 10.9583 12.1582 10.6001 12.6 10.6001C13.0418 10.6001 13.4 10.9583 13.4 11.4001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 11.4001C15.8 11.8419 15.4418 12.2001 15 12.2001C14.5582 12.2001 14.2 11.8419 14.2 11.4001C14.2 10.9583 14.5582 10.6001 15 10.6001C15.4418 10.6001 15.8 10.9583 15.8 11.4001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechRequest);
export default __webpack_public_path__ + "static/media/techRequest.d49d38ed0583da3def393f8205615a77.svg";
export { ForwardRef as ReactComponent };